module.exports = __webpack_public_path__ + "img/waves.83516966.png";